// extracted by mini-css-extract-plugin
export var dropdown = "_qv-0";
export var imageWrapper = "_qv-3";
export var itemNameContainer = "_qv-1";
export var productImage = "_qv-2";
export var spinnerWrapper = "_qv-4";